import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://drugawarenessusa.net';
const DEFAULT_IMAGE = `${SITE_URL}/og-image.jpg`;

export default function SEO({
  title,
  description,
  path = '/',
  image = DEFAULT_IMAGE,
  type = 'website',
}) {
  const fullTitle = title
    ? `${title} | DrugAwarenessUSA.net`
    : 'DrugAwarenessUSA.net | Drug & Alcohol Awareness Program';
  const url = `${SITE_URL}${path}`;
  const desc =
    description ||
    'Kress & Associates provides the Drug and Alcohol Awareness program — educating grades 6-12 across Western Pennsylvania on the value of making the right choices.';

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="DrugAwarenessUSA.net" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={image} />

      {/* Robots */}
      <meta name="robots" content="index, follow" />
      <meta name="googlebot" content="index, follow" />

      {/* Structured Data — Organization */}
      <script type="application/ld+json">{JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: 'Kress & Associates',
        alternateName: 'DrugAwarenessUSA',
        url: SITE_URL,
        logo: `${SITE_URL}/logo.png`,
        description: 'Drug and Alcohol Awareness program for grades 6-12.',
        founder: 'Joseph M. Kress',
        address: {
          '@type': 'PostalAddress',
          streetAddress: '11600 West Greene Rd',
          addressLocality: 'Waterford',
          addressRegion: 'PA',
          postalCode: '16441',
          addressCountry: 'US',
        },
        contactPoint: {
          '@type': 'ContactPoint',
          telephone: '+1-814-460-8447',
          contactType: 'customer service',
          areaServed: 'US',
        },
      })}</script>
    </Helmet>
  );
}
